import { combineReducers } from 'redux';
import { default as list } from 'inpc/reducers/inpc_list_reducers';
import { default as form } from 'inpc/reducers/inpc_form_reducers';

export const inpcReducers = combineReducers({ list, form });



// WEBPACK FOOTER //
// src/modules/secured/modules/inpc/reducers/index.js